import tinycolor from 'tinycolor2';

export const getRgbaColor = (color = '#000', opacity = 1) => {
  const toColor = tinycolor(color === 'transparent' ? '#FFF' : color);
  toColor.setAlpha(opacity);

  return toColor.toRgbString();
};
